class CPopup {
  constructor(params = {}) {
    this.defaultParams = {
      btnOkTitle: 'Ок',
      btnCancelTitle: 'Отмена',
      btnOkFn: () => {},
      btnCancelFn: () => {},
      cancelFn: () => {},
      templateName: 'default',
      template: '<h3>{{title}}</h3>{{#value}}<p>{{.}}</p>{{/value}}',
      data: {
        title: '&nbsp;',
        value: ''
      }
    }
    this.userParams = params;
    return this;
  }

  setParam(name, value) {
    this.userParams[name] = value;
    return this;
  }

  setParams(params) {
    this.userParams = $.extend({}, this.userParams, params);
    return this;
  }

  prepairClasses() {
    if (typeof this.userParams.classes !== 'undefined') {
      return Array.isArray(this.userParams.classes)
        ? this.userParams.classes.join(' ')
        : this.userParams.classes;
    }
    return '';
  }

  showPopup() {
    CPopup.uniqId = (CPopup.uniqId ?? 1) + 1;
    const uniqId = CPopup.uniqId;

    const params = $.extend({}, this.defaultParams, this.userParams);
    const containerId = (params.templateName + '-outer-' + uniqId);

    const contentStr = params.innerHTML ?? Mustache.render(params.template, params.data, params.include_templates ?? {});
    let $outer = $(`<div class="wrap-popup-pane popups-plugin ${ this.prepairClasses() }">`).attr('id', containerId);

    const fancyboxObj = $.fancybox.open({
      type : 'html',
      src  : $('<div>').append($outer).html(),
      opts : {
        modal : false,
        touch: false,
        animationDuration: 10,
        smallBtn: 'auto',
        parentEl: params.parentEl ?? 'body',
        buttons: [
          'close'
        ],
        beforeShow: function() {
          if(typeof params.beforeShow == 'function'){
            params.beforeShow( containerId );
          }
        },
        afterShow: function(){
          $('#' + containerId).append(contentStr).animate({opacity:1},10);
          const fancyCounter = parseInt($('body').data('fancybox-counter') ?? 0);

          if ((params.parentEl ?? 'body') === 'body') {
            $('body')
              .addClass('compensate-for-scrollbar')
              .data('fancybox-counter', fancyCounter + 1);
          } else if (fancyCounter === 0) {
            $('body').removeClass('compensate-for-scrollbar');
          }

          if(typeof params.afterShow == 'function'){
            params.afterShow( containerId );
          }

          if(typeof params.btnOkFn == 'function'){
            $('#' + containerId).on('keyup', function(e){
              if(e.keyCode == 13){
                params.btnOkFn(uniqId);
              }
            })
          }

        },
        beforeClose: function() {
          if(typeof params.beforeClose == 'function'){
            params.beforeClose( containerId );
          }
        },
        afterClose: function(){
          params.cancelFn();

          if(typeof params.afterClose == 'function'){
            params.afterClose( containerId );
          }

          if ((params.parentEl ?? 'body') === 'body') {
            const fancyCounter = parseInt($('body').data('fancybox-counter')) - 1;
            $('body').data('fancybox-counter', fancyCounter > 0 ? fancyCounter : 0);
          }

          if ((params.parentEl ?? 'body') === 'body' && parseInt($('body').data('fancybox-counter') ?? 0) === 0) {
            $('body').removeClass('compensate-for-scrollbar');
          }
        }
      }
    });
  }
}